import elementBase from "../elementBase.js";
import imageFormat from "../../definition/imageFormat.js";

export default class DynamicImage extends elementBase {
    objectType = "DynamicImage";
    Format = null;
    styleColor = '#553c9a'; // Violet foncé

    constructor(args = {}) {
        super(args);
        this.objectToClassValue(args);
    }
    objectToClassValue(args = {}) {
        super.objectToClassValue(args);
        this.Format = args.format != null ? this.getIdFromText(args.format, imageFormat) : this.getIdFromText("Ajuster", imageFormat);
    }

    get FormatName() {
        return imageFormat.find(el => el.idSoft == this.Format).name;
    }

    static get Name() {
        return "Image Statique";
    }
    get changeableProperty() {
        const parentProperty = super.changeableProperty;
        return [
            ...parentProperty.filter(el => el.type != "objectInput" && el.type != "arrayInput"),
            { name: "Format", type: "selectInput", dataType: "string", options: imageFormat, optionsType: "idSoft" },
            ...parentProperty.filter(el => el.type == "objectInput" || el.type == "arrayInput")
        ];
    }
    getStyle(currentElementIndex = null) {
        let style = {
            ...super.getStyle(currentElementIndex),
            backgroundImage: "url(/assets/images/Clemence.png)",
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            position: 'absolute',
        }
        const format = imageFormat.find(format => format.idSoft == this.Format);
        if (format) {
            style = format.action(style);
        }
        else {
            style.backgroundSize = 'cover';
        }
        return style;
    }
    toExportObject(variableArray = [], ressourceArray = []) {
        return {
            ...super.toExportObject(variableArray, ressourceArray),
            format: this.FormatName,
        };
    }

    toObject(minify = false) {
        let object = {
            ...super.toObject(minify),
            format: this.FormatName,
        };
        return object;
    }
}
